import { styled } from '@linaria/react';
import React from 'react';
import Button from '../Button';

const ActionButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  row-gap: 24px;
  flex-direction: column;
  max-width:279px;
  margin:auto;
  @media screen and (min-width: 768px) {
    flex-direction: row;
    column-gap: 24px;
  }
`;

export interface ActionButtonProps {
  actionType: 'confirm' | 'close';
  closeLabel?: string;
  confirmlabel?: string;
  width?: string;
  onClose?: () => void;
  onConfirm?: () => void;
}

const ActionButton = ({
  actionType,
  closeLabel,
  confirmlabel,
  width,
  onClose,
  onConfirm,
}: ActionButtonProps) => {
  return (
    <ActionButtonContainer>
      {actionType && (
        <Button
          label={closeLabel}
          variant={actionType === 'close' ? 'default' : 'secondary'}
          width={width}
          margin={0}
          onClick={onClose}
        />
      )}
      {actionType === 'confirm' && (
        <Button label={confirmlabel} width={width} margin={0} onClick={onConfirm} />
      )}
    </ActionButtonContainer>
  );
};

export { ActionButton };
